import * as React from 'react';

const SvgUpdateInstagram = (props) => (
  <svg
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      x={2.25}
      y={2.25}
      width={31.5}
      height={31.5}
      rx={6}
      fill='url(#updateInstagram_svg__a)'
    />
    <rect
      x={2.25}
      y={2.25}
      width={31.5}
      height={31.5}
      rx={6}
      fill='url(#updateInstagram_svg__b)'
    />
    <rect
      x={2.25}
      y={2.25}
      width={31.5}
      height={31.5}
      rx={6}
      fill='url(#updateInstagram_svg__c)'
    />
    <path
      d='M25.875 11.813a1.687 1.687 0 1 1-3.375 0 1.687 1.687 0 0 1 3.375 0Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 23.625a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Zm0-2.25a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75Z'
      fill='#fff'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.75 17.55c0-3.78 0-5.67.736-7.114a6.75 6.75 0 0 1 2.95-2.95c1.444-.736 3.334-.736 7.114-.736h.9c3.78 0 5.67 0 7.114.736a6.75 6.75 0 0 1 2.95 2.95c.736 1.444.736 3.334.736 7.114v.9c0 3.78 0 5.67-.736 7.114a6.75 6.75 0 0 1-2.95 2.95c-1.444.736-3.334.736-7.114.736h-.9c-3.78 0-5.67 0-7.114-.736a6.75 6.75 0 0 1-2.95-2.95C6.75 24.12 6.75 22.23 6.75 18.45v-.9ZM17.55 9h.9c1.927 0 3.238.002 4.25.084.987.081 1.491.227 1.843.406a4.5 4.5 0 0 1 1.966 1.967c.18.352.326.856.407 1.843.082 1.012.084 2.323.084 4.25v.9c0 1.927-.002 3.238-.084 4.25-.081.987-.227 1.491-.407 1.843a4.5 4.5 0 0 1-1.966 1.966c-.352.18-.856.326-1.843.407-1.012.082-2.323.084-4.25.084h-.9c-1.927 0-3.238-.002-4.25-.084-.987-.081-1.491-.227-1.843-.407a4.5 4.5 0 0 1-1.967-1.966c-.179-.352-.325-.856-.406-1.843C9.002 21.688 9 20.377 9 18.45v-.9c0-1.927.002-3.238.084-4.25.081-.987.227-1.491.406-1.843a4.5 4.5 0 0 1 1.967-1.967c.352-.179.856-.325 1.843-.406C14.312 9.002 15.623 9 17.55 9Z'
      fill='#fff'
    />
    <defs>
      <radialGradient
        id='updateInstagram_svg__a'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='rotate(-55.376 31.405 .074) scale(28.7096)'
      >
        <stop stopColor='#B13589' />
        <stop offset={0.793} stopColor='#C62F94' />
        <stop offset={1} stopColor='#8A3AC8' />
      </radialGradient>
      <radialGradient
        id='updateInstagram_svg__b'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='rotate(-65.136 33.487 7.75) scale(25.4185)'
      >
        <stop stopColor='#E0E8B7' />
        <stop offset={0.445} stopColor='#FB8A2E' />
        <stop offset={0.715} stopColor='#E2425C' />
        <stop offset={1} stopColor='#E2425C' stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id='updateInstagram_svg__c'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='rotate(-8.13 24.026 -2.27) scale(43.7522 9.35815)'
      >
        <stop offset={0.157} stopColor='#406ADC' />
        <stop offset={0.468} stopColor='#6A45BE' />
        <stop offset={1} stopColor='#6A45BE' stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgUpdateInstagram;
